/* Ported from ac-cat-v2 assets/pdp-related.js. */
/* Atlas PDP related products: hover image swap, quick add (sizes), "Added to cart" state. */
(function () {
  function init(sec) {
    if (sec.__pdpRel) return;
    sec.__pdpRel = true;
    sec.querySelectorAll('[data-card]').forEach((card) => {
      let t = null;
      card.addEventListener('mouseenter', () => card.classList.add('is-hover'));
      card.addEventListener('mouseleave', () => { card.classList.remove('is-hover', 'is-open'); });
      const plus = card.querySelector('[data-open-quick]');
      if (plus) plus.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); card.classList.add('is-open'); });
      card.querySelectorAll('[data-add]').forEach((b) => b.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        if (b.disabled || card.classList.contains('is-busy')) return;
        const A = window.Atlas;
        if (!A || !A.cart) return;
        card.classList.add('is-busy');
        b.classList.add('is-loading');
        A.cart.add([{ id: +b.dataset.add, quantity: 1 }]).then(() => {
          card.classList.remove('is-open');
          card.classList.add('is-added');
          clearTimeout(t);
          t = setTimeout(() => card.classList.remove('is-added'), 1800);
        }).catch(() => {}).then(() => { card.classList.remove('is-busy'); b.classList.remove('is-loading'); });
      }));
    });
  }
  function boot() { document.querySelectorAll('.pdpr').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
